import { useState } from 'react';
import { BodyConfirmModal } from './body/body_confirm_modal.component';
import BaseModal from './base_modal.component';
import { WarningIcon } from 'components/icons/warning_icon.component';


interface ConfirmNavModalProviderProp {
  onConfirm: () => void;
  onClose?: () => void;
  t: ( key: string ) => string;
}

export const ConfirmNavModal: React.FC<ConfirmNavModalProviderProp> = ( { onConfirm, onClose, t }: ConfirmNavModalProviderProp ) => {
  const [ isOpen, setIsOpen ] = useState( true );

  const close = () => {
    setIsOpen( false );
    if ( onClose ) {
      onClose();
    }
  };

  const confirm = () => {
    onConfirm();
    close();
  };

  return (
    <>
      {
        isOpen &&
          <BaseModal
            title={ t( 'translation:are_you_sure' ) }
            isOpen={ isOpen }
            onClose={ close }
            icon={ <WarningIcon className='w-10 p-2 fill-white'/> }
            noConfirmationModal={ true }
          >
            <BodyConfirmModal
              onCancel={ close }
              onConfirm={ confirm }
              color='#4986f3'
              colorHover='#3579F2'
              t={ t }
            >
              <div className='p-2'>
                { t( 'translation:you_will_lose_informations' ) }
              </div>
            </BodyConfirmModal>
          </BaseModal>
      }
    </>
  );
};